import React from 'react'
import Drawer from "react-drag-drawer";
import { playSong } from '../../utils/song'
import songsName from '../../enums/songsName'
import { FiX } from 'react-icons/fi';
import LogoPng from '../../assets/images/new/dum-dum-logo.png'
import { BsArrowLeftCircle } from 'react-icons/bs';

const KnowMoreModal = (props) => {
  const closeHandler = () => {
    playSong(songsName.TAP)
    props.close()
  }

  return (
    <Drawer
      dontApplyListeners={true}
      allowClose={false}
      open={props.isOpened}
      onRequestClose={props.close}
      direction="left"
      modalElementClass="absolute top-0 left-0"
    >
      <div
        className='w-screen max-w-lg h-screen bg-modal flex flex-col justify-start items-start px-4 text-lg overflow-y-auto'
        style={{
          paddingTop: window.native_app_status_bar_height ?? 16,
          paddingBottom: window.native_app_navigation_bar_height ?? 16
        }}
      >
        <div className='w-full flex flex-row justify-between items-center'>
          <div
            className='flex flex-row justify-start items-center cursor-pointer'
            onMouseEnter={() => {
              playSong(songsName.TAP)
            }}
            onClick={() => {
              playSong(songsName.TAP)

              props.backToDrawerMenu()
            }}
          >
            <BsArrowLeftCircle className="w-8 h-8 text-blue-primary" />
          </div>

          <img src={LogoPng} className='w-40 h-12 mx-auto' alt='Logo' />

          <button
            type="button"
            onMouseEnter={() => {
              playSong(songsName.TAP)
            }}
            onClick={closeHandler}
            className={`text-black bg-transparent hover:bg-slate-200 rounded-lg text-2xl lg:text-xl`}
          >
            <FiX className="w-8 h-8 text-blue-primary" />
          </button>
        </div>

        <h2 className='text-blue-primary font-bold text-xl text-center mx-auto my-8'>Como funciona</h2>

        <div className='text-lg'>
          <p className='mb-2'>Que tal começar a primeira biblioteca dos pequenos?</p>
          <p className='mb-2'>Fazendo parte do dum dum livros você adquire dois livros para a infância a cada mês, que farão parte da sua biblioteca. Os livros são cuidadosamente selecionados por uma equipe de curadoria, e conjugam entretenimento e educação, disseminando valores como respeito, amizade, empatia e inclusão. Os livros, sempre de autores brasileiros, são ricamente ilustrados e acompanhados de narração, para que mesmo as crianças em idade pré-escolar possam aproveitar.</p>
          <p className='mb-2'>Para fazer parte, você pode fazer uma assinatura ou entrar com uma empresa parceira. Além de receber novos livros todos os meses, você ganha uma biblioteca de presente quando se junta ao dum dum livros.</p>
          <p className='mb-2'>Leia os livros on-line e baixe para ler sem estar conectado e guardá-los para sempre. Os livros são seus, permanecem na sua biblioteca mesmo que você deixe de ser assinante ou cliente da empresa parceira. Basta fazer download.</p>
          <p className='mb-2'>Transforme o tempo de tela das crianças em tempo de educação e formação dos leitores do futuro!</p>
          <p className='text-sm'>* Antes de assinar ou entrar, leia os Termos de Uso</p>
        </div>
      </div>
    </Drawer>
  )
}

export default KnowMoreModal